export default "__VITE_ASSET__BG$SKfe1__"